import { e } from '@frontend/shared/src/utils/e';
import { WallOfShameUser } from '../wall-of-shame-user/wall-of-shame-user';
import { WallOfShame, type WOSAPIUser } from '../../services/WallOfShameService';
import { WallOfShameDialogUserSettings } from '../wall-of-shame-user/wall-of-shame-dialog-user-settings/wall-of-shame-dialog-user-settings';

const ATTR = 'wall-of-shame-app';

export class WallOfShameApp extends HTMLBodyElement {
  #grid_element = document.querySelector<HTMLDivElement>('.grid')!;

  #add_button = document.querySelector<HTMLButtonElement>('header .add-new')!;

  constructor() {
    super();

    this.setAttribute('is', ATTR);
  }

  connectedCallback() {
    WallOfShame.load_all().then(users => {
      this.#set_inital_items(users.sort((a, b) => (a.unban_ts > b.unban_ts ? -1 : 1)));
    });
  }

  #set_inital_items = (users: WOSAPIUser[]) => {
    this.#grid_element.innerHTML = '';

    const items_elements = users.map(user =>
      e.div({ className: 'item' }, [WallOfShameUser.from_api(user)])
    );

    this.#grid_element.append(...items_elements);

    this.#add_button.addEventListener('click', () => {
      this.#grid_element.append(WallOfShameDialogUserSettings.from_new());
    });
  };
}

customElements.whenDefined(ATTR).then(() => console.log('[DEFINED]', ATTR));
customElements.define(ATTR, WallOfShameApp, { extends: 'body' });
